import { isEmpty, map } from 'lodash'

const userEditorFormInitialValues = values => {
  if (isEmpty(values)) return { isActive: true }

  return {
    ...values,
    roleIds: map(values.roles, 'id'),
    languageIds: map(values.languages, 'id'),
    cuisineTypeIds: map(values.cuisineTypes, 'id'),
  }
}

export default userEditorFormInitialValues
